// extracted by mini-css-extract-plugin
module.exports = {"tab":"ChatGPTPopup_tab__UMYnr","tabItem":"ChatGPTPopup_tabItem__qDOJJ","top":"ChatGPTPopup_top__UlXlB","colse":"ChatGPTPopup_colse__RwlbV"};